import React from 'react';
import PropTypes from 'prop-types';
import {Box, Typography} from '@mui/material';

const formatPrice = (value) => {
  if (value == null || value === '') return '$0.00';
  const asNumber = Number(String(value).replace(/[^0-9.-]/g, ''));
  if (Number.isNaN(asNumber)) return String(value);
  return `$${asNumber.toFixed(2)}`;
};

export const PriceListFlyerTemplate = ({companyName, services, isContinuationPage, isLastPage}) => {
  const safeCompanyName = companyName?.trim() || 'Your Company';
  const siteOrigin = typeof window !== 'undefined' ? window.location.origin : '';
  const iPermitLogoUrl = `${siteOrigin}/iPermitPro.png`;

  return (
    <Box
      sx={{
        width: '8.5in',
        height: '11in',
        backgroundColor: '#e6eaed',
        position: 'relative',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        padding: '24px 32px',
        boxSizing: 'border-box',
        fontFamily: 'Montserrat, sans-serif',
        WebkitFontSmoothing: 'antialiased',
      }}
    >
      <Box sx={{position: 'absolute', top: '-10%', left: '-10%', width: '50%', height: '50%', backgroundColor: '#fff', transform: 'rotate(45deg)', zIndex: 0}} />
      <Box sx={{position: 'absolute', bottom: '-20%', right: '-10%', width: '80%', height: '60%', backgroundColor: '#fff', transform: 'rotate(-35deg)', zIndex: 0}} />
      <Box sx={{position: 'absolute', bottom: '10%', left: '-20%', width: '40%', height: '40%', backgroundColor: '#f1f4f6', transform: 'rotate(15deg)', zIndex: 0}} />

      <Box sx={{position: 'relative', zIndex: 10, flexGrow: 1, display: 'flex', flexDirection: 'column'}}>
        {!isContinuationPage && (
          <>
            <Box sx={{width: '100%', textAlign: 'center', borderBottom: '2px solid #d1d5db', pb: 1, mb: 3}}>
              <div style={{fontSize: '1.25rem', fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#4b5563'}}>
                {safeCompanyName}
              </div>
            </Box>

            <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 3}}>
              <Box sx={{display: 'flex', flexDirection: 'column', mt: 2}}>
                <img
                  src={iPermitLogoUrl}
                  alt="iPermit Pro"
                  style={{width: 280, height: 'auto', display: 'block'}}
                />
              </Box>
            </Box>

            <Box sx={{mb: 2}}>
              <Box sx={{display: 'inline-block', backgroundColor: '#8cc63f', borderRadius: '4px', px: 1.5, py: 0.5, mb: 1}}>
                <Typography
                  component="span"
                  sx={{fontSize: '24px', fontWeight: 700, color: '#1e375a', letterSpacing: '0.05em', lineHeight: 1.2}}
                >
                  BUNDLED PRICING
                </Typography>
              </Box>
              <div style={{color: '#1e375a', fontWeight: 700, fontSize: '1.125rem', marginBottom: 16}}>
                Bundle all services with iPermit for one flat rate.
              </div>
              <Box sx={{display: 'inline-block', backgroundColor: '#8cc63f', borderRadius: '4px', px: 1.5, py: 0.5}}>
                <Typography
                  component="span"
                  sx={{fontSize: '24px', fontWeight: 700, color: '#1e375a', letterSpacing: '0.05em', lineHeight: 1.2}}
                >
                  PERMIT SERVICES
                </Typography>
              </Box>
            </Box>
          </>
        )}
        <Box sx={{backgroundColor: '#1e375a', color: '#fff', borderRadius: '8px', p: '32px 24px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)', width: '105%', ml: '-8px', mb: 3, boxSizing: 'border-box'}}>
          {services.map((service, index) => (
            <div key={`${service.name}-${index}`} style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: 10}}>
              <span style={{fontWeight: 700, fontSize: 17, letterSpacing: '0.025em', whiteSpace: 'nowrap'}}>
                {service.name}
              </span>
              <div style={{flexGrow: 1, margin: '0 12px', position: 'relative', top: -6, borderBottom: '4px dotted white', opacity: 0.8}} />
              <span style={{fontWeight: 700, fontSize: '1.25rem', letterSpacing: '0.025em', whiteSpace: 'nowrap'}}>
                {formatPrice(service.price)}
              </span>
            </div>
          ))}
        </Box>

        {isLastPage && (
          <Box sx={{textAlign: 'center', mb: 3}}>
            <div style={{color: '#1e375a', fontWeight: 700, fontStyle: 'italic', fontSize: '1.125rem', letterSpacing: '0.025em', textTransform: 'uppercase'}}>
              From permit to final inspection, ipermit handles it all!
            </div>
          </Box>
        )}
      </Box>
    </Box>
  );
};

PriceListFlyerTemplate.propTypes = {
  companyName: PropTypes.string,
  isContinuationPage: PropTypes.bool,
  isLastPage: PropTypes.bool,
  services: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ),
};

PriceListFlyerTemplate.defaultProps = {
  companyName: 'Your Company',
  isContinuationPage: false,
  isLastPage: true,
  services: [],
};
